import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import isObject from 'lodash/isObject'
import { me } from '../initial_state'
import PageTitle from '../features/ui/util/page_title'
import DefaultLayout from '../layouts/default_layout'
import {
  addShortcut,
  removeShortcut,
 } from '../actions/shortcuts' 
import { GroupsPanel, LinkFooter, UserSuggestionsPanel } from '../features/ui/util/async_components'
import RandomSidebarPanels from '../components/sidebar/random_sidebar_panels'
import { shuffle } from 'lodash'
import ShortcutsPanel from '../components/panel/shortcuts_panel'
import WrappedBundle from '../features/ui/util/wrapped_bundle'

class HashtagPage extends React.PureComponent {

  handleOnToggleShortcut = () => {
    const {
      isShortcut,
      hashtag,
      shortcut,
      onAddShortcut,
      onRemoveShortcut
    } = this.props

    if (isShortcut) {
      onRemoveShortcut(shortcut)
    } else {
      onAddShortcut(hashtag)
    }
  }
    
  render() {
    const { isShortcut, children, hashtag } = this.props

    const actions = !!me ? [{
      icon: isShortcut ? 'star' : 'star-outline',
      onClick: this.handleOnToggleShortcut,
    }] : []

    const items = RandomSidebarPanels()
    const sidebarLayout = [
      ...shuffle(items),
      LinkFooter,
    ]

    const sidebarChildren = [
      <ShortcutsPanel type='tag' noPanel />,
      <WrappedBundle key='hashtag-page-groups-panel' component={GroupsPanel} componentParams={{ groupType: 'featured', noPanel: 1, max: 6, padded: 1 }} />,
      <WrappedBundle key='hashtag-page-user-suggestions-panel' component={UserSuggestionsPanel} componentParams={{ suggestionType: 'verified', noPanel: 1, padded: 1 }} />,
    ]

    return (
      <DefaultLayout
        showBackBtn
        title='Tag Timeline'
        page={`hashtag.${hashtag}`}
        layout={sidebarLayout}
        actions={actions}
        sidebarChildren={sidebarChildren}
      >
        <PageTitle path={`#${hashtag} timeline`} />
        <div className={[_s.d, _s.w100PC, _s.px15, _s.py15].join(' ')}>
          <span
            className={[_s.w100PC, _s.text, _s.fs15PX, _s.textOverflowEllipsis, _s.cPrimary].join(' ')}
            dangerouslySetInnerHTML={{ __html: `#${hashtag}` }}
          />
        </div>
        {children}
      </DefaultLayout>
    )
  }
}

const mapStateToProps = (state, { params }) => {
  const submittedId = isObject(params) && params.id ? params.id.toLowerCase() : ''
  const hashtag = checkHash(submittedId)
  const shortcuts = state.getIn(['shortcuts', 'items'])
  const shortcut = shortcuts.find((s) => {
    return `${s.get('title')}`.toLowerCase() == hashtag && s.get('shortcut_type') === 'tag'
  })

  return {
    hashtag,
    shortcut,
    isShortcut: !!shortcut,
  }
}

const checkHash = function(hashtag = '') {
  const hashRegex = /[\w\u0590-\u05ff]+/g
  const matches = hashtag.match(hashRegex) || []
  return matches && matches[0] ? matches[0].toLowerCase() : ''
}

const mapDispatchToProps = (dispatch) => ({
  onAddShortcut(hashtag) {
    dispatch(addShortcut('tag', hashtag))
  },
  onRemoveShortcut(shortcut) {
    if (!shortcut) return
    dispatch(removeShortcut(shortcut.get('id'), 'tag'))
  },
})
 
 
HashtagPage.propTypes = {
  children: PropTypes.node.isRequired,
  onAddShortcut: PropTypes.func.isRequired,
  onRemoveShortcut: PropTypes.func.isRequired,
  hashtag: PropTypes.string.isRequired,
  params: PropTypes.object.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(HashtagPage)
